import { InputField } from "components/designV2/inputfield/inputfield";
import { useTranslation } from "react-i18next";
import { normalizeNumber } from "web-apps/company/components/common/number.normalize.logic";
import {
  PassSettingControlLabel,
  PassSettingControls,
  PassSettingDescription,
  PassSettingLabeledControl,
  PassSettingSection,
  PassSettingText,
  PassSettingTitle,
  SettingsGroupTitle,
  SettingsSubRow,
  SettingsSubRows,
} from "./passSettingsV2.styled";

type Props = {
  afterEndValue: number;
  afterStartValue: number;
  beforeStartValue: number;
  beforeEndValue: number;
  onChangeAfterEnd: (v: number) => void;
  onChangeAfterStart: (v: number) => void;
  onChangeBeforeStart: (v: number) => void;
  onChangeBeforeEnd: (v: number) => void;
};

export const TimeReportStampThresholdSettings: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const handleNumberChange =
    (onChange: (value: number) => void) =>
    (nextValue: string): void => {
      const normalizedValue = normalizeNumber(nextValue);
      if (normalizedValue !== null) onChange(normalizedValue);
    };

  return (
    <PassSettingSection>
      <PassSettingText>
        <PassSettingTitle>
          {t("System.TimeReportStampTreshHold")}
        </PassSettingTitle>
        <PassSettingDescription>
          {t("System.TimeReportStampTreshHoldInfo")}
        </PassSettingDescription>
      </PassSettingText>

      <SettingsSubRows>
        <SettingsSubRow>
          <SettingsGroupTitle>{t("System.StampIn")}</SettingsGroupTitle>
          <PassSettingControls>
            <PassSettingLabeledControl>
              <PassSettingControlLabel>
                {t("System.Before")}
              </PassSettingControlLabel>
              <InputField
                ariaLabel={t("System.BeforeStart")}
                value={String(props.beforeStartValue)}
                type="number"
                size="compact"
                onChange={handleNumberChange(props.onChangeBeforeStart)}
              />
            </PassSettingLabeledControl>
            <PassSettingLabeledControl>
              <PassSettingControlLabel>
                {t("System.After")}
              </PassSettingControlLabel>
              <InputField
                ariaLabel={t("System.AfterStart")}
                value={String(props.afterStartValue)}
                type="number"
                size="compact"
                onChange={handleNumberChange(props.onChangeAfterStart)}
              />
            </PassSettingLabeledControl>
          </PassSettingControls>
        </SettingsSubRow>

        <SettingsSubRow>
          <SettingsGroupTitle>{t("System.StampOut")}</SettingsGroupTitle>
          <PassSettingControls>
            <PassSettingLabeledControl>
              <PassSettingControlLabel>
                {t("System.Before")}
              </PassSettingControlLabel>
              <InputField
                ariaLabel={t("System.BeforeEnd")}
                value={String(props.beforeEndValue)}
                type="number"
                size="compact"
                onChange={handleNumberChange(props.onChangeBeforeEnd)}
              />
            </PassSettingLabeledControl>
            <PassSettingLabeledControl>
              <PassSettingControlLabel>
                {t("System.After")}
              </PassSettingControlLabel>
              <InputField
                ariaLabel={t("System.AfterEnd")}
                value={String(props.afterEndValue)}
                type="number"
                size="compact"
                onChange={handleNumberChange(props.onChangeAfterEnd)}
              />
            </PassSettingLabeledControl>
          </PassSettingControls>
        </SettingsSubRow>
      </SettingsSubRows>
    </PassSettingSection>
  );
};
